import React, { useState } from "react";
import logoIcon from "../../src/logo/logo.svg";
function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header d-flex align-items-center">
          <button
            type="button"
            className="navbar-toggle collapsed"
            onClick={toggleMenu}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand" href="/#home">
            <div className="d-flex align-items-center">
              <img src={logoIcon} alt="Logo" height="40" className="me-2" />
              <span className="brand-name">Chamara Silva</span>
            </div>
          </a>
        </div>

        <div className={`collapse navbar-collapse ${isMenuOpen ? "in" : ""}`}>
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="/#home" className="active">
                Home
              </a>
            </li>
            <li>
              <a href="/#about">About</a>
            </li>
            <li>
              <a href="/#skill">Skill</a>
            </li>
            <li>
              <a href="/#resume">Education</a>
            </li>
            <li>
              <a href="/#service">Service</a>
            </li>
            <li>
              <a href="/#blog">Blog</a>
            </li>
            <li>
              <a href="/#contact">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;
